<template>
    <div class="page_banner_mobile">
        <div class="contact_us flex-col" :style="bannerStyle">
            <div class="text-group_108 flex-col justify-between">
                <span class="text_8">联系我们</span>
                <span class="text_9">Contact us</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            contactBanner: {
                type: String,
                required: true
            },
            contactBannerText: {
                type: String,
                default: '自研3C企业健康管理服务体系'
            }
        },
        data() {
            return {
                //contactBanner: require('@/assets/news/news_banner_01.png')
            };
        },
        computed: {
            bannerStyle() {
                return {
                    backgroundImage: `url(${this.contactBanner})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                };
            }
        },
        methods: {

        }
    };
</script>

<style scoped lang="css">

    .page_banner_mobile {
        width: 100%;
        margin: 0 auto;
        align-items: center;
    }

    .contact_us {
        width: 100%;
        height: 230px;
        position: relative;
        display: flex;
        justify-content: center;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text-group_108 {
        width: 179px;
        height: 130px;
        margin-left: 40px;
        justify-content: center !important;
        gap: 4px;
    }

    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_8 {
        width: 174px;
        height: 70px;
        overflow-wrap: break-word;
        color: #008683;
        font-size: 34px;
        font-weight: 600;
        font-family: AlibabaPuHuiTi_3_85_Bold;
        text-align: left;
        white-space: nowrap;
        line-height: 70px;
    }

    .text_9 {
        width: 179px;
        height: 70px;
        overflow-wrap: break-word;
        font-size: 20px;
        color: #666666;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        white-space: nowrap;
        line-height: 70px;
        margin-top: -10px;
    }

    /* 中等屏幕样式 */
    @media (min-width: 480px) {
        .text_8 {
            font-size: 26px;
        }
        .text_9 {
            font-size: 20px;
        }
    }

    /* 小屏幕样式（屏幕宽度小于等于750px） */
    @media (max-width: 700px) {
        .contact_us {
            /*height: 25vh; */
            height: 115px;
            width: 100%;
        }

        .text-group_108 {
            width: 80%; /* 根据需要调整宽度 */
            margin-left: 20px; /* 调整左边距以适应小屏幕 */
        }

        .text_8 {
            font-size: 4vw; /* 使用相对字体大小 */
            height: 30px;
            line-height: 40px;
        }

        .text_9 {
            font-size: 3vw; /* 使用相对字体大小 */
            height: 37px;
            line-height: 37px;
        }

        .text_8 {
            margin-bottom: 10px; /* 增加间距以改善可读性 */
        }
    }
</style>
